export const haveSameElements = (a: any[], b: any[]) => {
  if (a.length !== b.length) return false;

  return a.every((item) => b.includes(item));
};
